/* solutionRegistrations.js */

"use strict";
const Registrations = require("./RegistrationNamespaces");

class SolutionRegisterer {
    constructor(steveDi) {
        /****************************/
        /* SOLUTIONS                */
        /****************************/

        const Classic = require("./solutions/Classic");
        steveDi.registry.register(Registrations.CLASSIC_SOLUTION, Classic);

        const WorkflowExplorer = require("./solutions/WorkflowExplorer");
        steveDi.registry.register(Registrations.WORKFLOW_EXPLORER, WorkflowExplorer);

        // const Routing = require("./solutions/Routing");
        // steveDi.registry.register(Registrations.ROUTING_SOLUTION, Routing);

        const Rpa = require("./solutions/rpa");
        steveDi.registry.register(Registrations.RPA_SOLUTION, Rpa);

        const Topology = require("./solutions/topology");
        steveDi.registry.register(Registrations.TOPOLOGY_SOLUTION, Topology);

        /****************************/
        /* UTILITY SOLUTIONS        */
        /****************************/

        const CdriftSolution = require("./solutions/utilities/ConfigDrift");
        steveDi.registry.register(Registrations.CD_UTILITY_SOLUTION, CdriftSolution);

        const DataExportSolution = require("./solutions/utilities/DataExport");
        steveDi.registry.register(Registrations.DATA_EXPORT_UTILITY_SOLUTION, DataExportSolution);

        const OsManagerSolution = require("./solutions/utilities/OsManager");
        steveDi.registry.register(Registrations.OS_MANAGER_UTILITY_SOLUTION, OsManagerSolution);

        /****************************/
        /* ADMINISTRATION SOLUTIONS */
        /****************************/

        const DashboardSolution = require("./solutions/administration/Dashboard");
        steveDi.registry.register(
            Registrations.DASHBOARD_ADMINISTRATION_SOLUTION,
            DashboardSolution
        );

        const DeviceManagerSolution = require("./solutions/administration/DeviceManager");
        steveDi.registry.register(
            Registrations.DEVICE_MANAGER_ADMINISTRATION_SOLUTION,
            DeviceManagerSolution
        );

        const FileServerSolution = require("./solutions/administration/FileServer");
        steveDi.registry.register(
            Registrations.FILE_SERVER_ADMINISTRATION_SOLUTION,
            FileServerSolution
        );

        const WorkTrigSolution = require("./solutions/administration/WorkTriggers");
        steveDi.registry.register(
            Registrations.WORK_TRIG_ADMINISTRATION_SOLUTION,
            WorkTrigSolution
        );

        const SettingsSolution = require("./solutions/administration/SystemSettings");
        steveDi.registry.register(Registrations.SETTINGS_ADMINISTRATION_SOLUTION, SettingsSolution);

        const PackageManagement = require("./solutions/administration/SolutionsManagement");
        steveDi.registry.register(Registrations.PACKAGE_ADMINISTRATION_SOLUTION, PackageManagement);

        const DataExplorerSolution = require("./solutions/administration/DataExplorer");
        steveDi.registry.register(
            Registrations.DATA_EXPLORER_ADMINISTRATION_SOLUTION,
            DataExplorerSolution
        );

        const VersionControlSolution = require("./solutions/administration/VersionControl");
        steveDi.registry.register(
            Registrations.VERSION_CONTROL_ADMINISTRATION_SOLUTION,
            VersionControlSolution
        );
    }
}

module.exports = SolutionRegisterer;
